module.exports = __webpack_public_path__ + "media/images/product/p_a-7d49ce9cd558d396822f9566ae1099e7.png";